export default "__VITE_ASSET__BYIRnQWj__"